import { Injectable } from "@angular/core";
import { LiveChatResponse } from "@obg/ngx.common/types";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { SupportConfigService } from "./support.config";

@Injectable({
	providedIn: "root",
})
export class SupportService {
	constructor(
		private client: CoreHttpClient,
		private config: SupportConfigService
	) {}

	getLiveChatUrl(): Observable<LiveChatResponse> {
		return this.client.get<LiveChatResponse>({
			url: `${this.config.getLiveChatUrlEndpoint()}`,
		});
	}
}
